import { render, staticRenderFns } from "./BackgroundForm.vue?vue&type=template&id=0b8ece64&scoped=true"
import script from "./BackgroundForm.vue?vue&type=script&lang=js"
export * from "./BackgroundForm.vue?vue&type=script&lang=js"
import style0 from "./BackgroundForm.vue?vue&type=style&index=0&id=0b8ece64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8ece64",
  null
  
)

export default component.exports